import { reactQueryGet } from "../helpers/backendRequestHelpers";
import { crmFilters } from "../helpers/urlHelpers/internalApi/crmFilters";

// TODO: check how those types can be inferred from the BE specs
interface CrmFilterConfiguration {
  filter_configurations: CrmFilterConfigurationItem[];
}

type CrmFilterConfigurationItem = LocationConfiguration | NearMeConfiguration;

export interface LocationConfiguration {
  type: "standard";
  key: "location";
  input_type: "location";
  label: "Location";
  payload: null;
}

export interface NearMeConfiguration {
  type: "action";
  key: "near_me";
  input_type: "near_me";
  label: "Near Me";
  payload: {
    near_me_location_filter_values: {
      source: string;
      id: string;
      name: string;
    } | null;
    community_member_profile_field: {
      id: string;
      text: string;
    } | null;
    require_user_to_provide_more_precise_location: boolean;
  };
}

const configuration = () =>
  reactQueryGet<CrmFilterConfiguration>(crmFilters.configuration());

export const crmFiltersApi = {
  configuration,
};
